import { Injectable, inject } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { WEEK_DATE_LABELS } from "../constants/analytics.constant";
import { DateState, PaymentBarState } from "../models/analytics.model";

@Injectable({
  providedIn: "root",
})
export class AnalyticsTranslationService {
  agentId: string | undefined;
  userId: number | undefined;

  constructor(private translateService: TranslateService) {}

  public mapDatesToLabels(dates?: string[], dateFilter?: DateState) {
    switch (dateFilter) {
      case DateState.Month:
        const monthLabels = dates?.map((item) => {
          const month = (this.mapToDateFormat(item).getMonth() + 1).toString().padStart(2, "0");
          const day = this.mapToDateFormat(item).getDate().toString().padStart(2, "0");
          return `${day}.${month}`;
        });
        return monthLabels || false;

      case DateState.Week:
        const weekLabels = dates?.map((item) => {
          const month = (this.mapToDateFormat(item).getMonth() + 1).toString().padStart(2, "0");
          const day = this.mapToDateFormat(item).getDate().toString().padStart(2, "0");

          return `${this.getDayOfWeekName(item)} ${day}.${month}`;
        });

        return weekLabels || false;

      case DateState.Year:
        const yearLabels = dates?.map((item) => {
          const date = this.mapToDateFormat(item);
          const year = date.getFullYear().toString();
          const month = (date.getMonth() + 1).toString().padStart(2, "0");
          return `${month}.${year}`;
        });
        return yearLabels || false;
    }

    return;
  }

  public mapToBarStateFormat(item: string) {
    switch (item) {
      case "PAYMENT_LINK":
        return PaymentBarState.LinkPayment;
      case "QR_CODE_PAYMENT":
        return PaymentBarState.QrPayment;
      case "PAYMENT_FROM_SITE":
        return PaymentBarState.SitePayment;
      case "RECURRENT_PAYMENTS":
        return PaymentBarState.RecurringPayment;
      default:
        return null;
    }
  }

  private getDayOfWeekName(dateStr: string) {
    const dayOfWeekIndex = this.mapToDateFormat(dateStr).getDay() - 1;
    if (dayOfWeekIndex === -1) {
      return this.translateService.instant(`ANALYTICS_PAGE.WEEK_LABELS.${WEEK_DATE_LABELS[6]}`);
    } else {
      return this.translateService.instant(`ANALYTICS_PAGE.WEEK_LABELS.${WEEK_DATE_LABELS[dayOfWeekIndex]}`);
    }
  }

  private mapToDateFormat(item: string) {
    // Разбиваем строку на составляющие
    const parts = item.split(/[- :]/);
    // Преобразуем строки в числа
    const year = parseInt(parts[2]);
    const month = parseInt(parts[1]) - 1; // вычитаем 1, так как месяцы начинаются с 0
    const day = parseInt(parts[0]);
    const hours = parseInt(parts[3]);
    const minutes = parseInt(parts[4]);

    return hours && minutes ? new Date(year, month, day, hours, minutes) : new Date(year, month, day);
  }
}
